module.exports = __webpack_public_path__ + "img/icon-white-58.f8e5de79.svg";